<template>
  <div class="u-marg-t-lg">
    <div class="available__title u-center t-h1 u-pad-b-md">
      {{ $t('available.date') }}
    </div>
    <div class="u-row u-pad-y-md">
      <div class="u-marg-l-1of12 u-w10of12 u-w8of12--sm u-marg-l-2of12--sm u-marg-l-3of12--xs u-w6of12--xs available__plateform__wrapper u-flex u-center">
        <div class="u-row u-row--sm u-center">
          <template v-for="platform in platforms">
            <a v-if="platform.name !== 'windows'" :title="platform.name" :key="platform.name" :href="platform.url" class="available__plateform u-w2of12 u-block u-pad-x-sm u-w6of12--sm u-w12of12--xs u-marg-t-sm" target="_blank">
              <img class="u-full-width" :alt="platform.name" :src="`/images/${platform.name}.png`">
            </a>
            <a v-else @click="$ga.send('download', 'microsoft')" :title="platform.name" :key="platform.name" :href="platform.url" class="available__plateform u-w2of12 u-block u-pad-x-sm u-w6of12--sm u-w12of12--xs u-marg-t-sm">
              <img class="u-full-width" :alt="platform.name" :src="`/images/${platform.name}.png`">
            </a>
          </template>
        </div>
      </div>
    </div>
    <div class="u-row u-pad-t-md u-pad-b-lg u-center">
      <div class="u-w4of12 u-w8of12--sm u-w3of12--xs">
        <div class="u-row u-row--md u-center--sm u-center">
          <div class="available__social__wrapper u-w4of12 u-pad-x-md u-w12of12--xs u-pad-y-md--sm" v-for="social in socials">
            <a :title="social.type" :href="social.link" target="_blank" class="u-block">
              <div class="u-box-1by1">
                <div class="available__social u-wrapper-panel u-flex u-middle u-center">
                  <div class="available__social__item">
                    <svg class="u-fit-cover" v-if="social.type !== 'Instagram'">
                      <use :xlink:href="'#icon-' + social.type.toLowerCase()"/>
                    </svg>
                    <img v-else class="u-fit-contain" :alt="social.type" :src="`/images/${social.type.toLowerCase()}.png`">
                  </div>
                </div>
              </div>
              <div class="u-marg-t-sm">
                {{ social.type }}
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimScroll from '@/components/common/AnimScroll'

export default {
  components: {
    AnimScroll
  },

  data () {
    return {
      socials: [
        {
          type: 'Facebook',
          link: 'https://www.facebook.com/centrepompidou.fr/'
        },
        {
          type: 'Twitter',
          link: 'https://mobile.twitter.com/CentrePompidou?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor'
        },
        {
          type: 'Instagram',
          link: 'https://www.instagram.com/centrepompidou/'
        }
      ] 
    }
  },
  props: {
    platforms: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="stylus" scoped>

@import '~@/styles/settings/variables'

.available
  &__plateform
    // max-width 200px
    
    &__wrapper
      display flex

  &__title
    font-size 50px    

  &__social
    border-radius 50%
    background-color: $colors.white
  
    &__wrapper
      max-width 150px  
    
    &__item
      height 30px
      width 30px

</style>